class Tag {
  constructor(tagData = {}) {
    this.id = tagData.id || null;
    this.name = tagData.name || "";
    this.description = tagData.description || "";
  }
}

export default Tag;
